import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnamneseConfiguracaoInserirComponent } from './anamnese-configuracao-inserir.component';

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', component: AnamneseConfiguracaoInserirComponent }
  ])],
  exports: [RouterModule]
})
export class AnamneseConfiguracaoInserirRoutingModule { }
